import { useEffect } from 'react';
import WaykePubSub from '../../utils/PubsubItem';

if (!window.WaykePubSubItem) {
  window.WaykePubSubItem = WaykePubSub;
}

window.WaykePubSubItem.subscribe({
  eventName: 'All',
  callback: (eventName: string, data: string[]) => {
    if (window.gtag) {
      window.gtag('event', eventName, {
        value: data,
      });
    } else if (window.dataLayer) {
      window.dataLayer.push({ event: eventName, data });
    }
  },
});

const hideAll = () => {
  document.querySelectorAll('.page__section').forEach((element) => {
    const isWaykeComposite = element.querySelector('.combined-search');
    if (!isWaykeComposite && element) {
      element.setAttribute('hidden', '');
    }
  });
};

const displayAll = () => {
  document.querySelectorAll('.page__section').forEach((element) => {
    element.removeAttribute('hidden');
  });
};

let hashRouteInit2 = false;

const useAnalytics = (id?: string) => {
  useEffect(() => {
    if (id) {
      hideAll();
    } else {
      displayAll();
    }

    if (!hashRouteInit2) {
      hashRouteInit2 = true;
    } else {
      if (window.gtag) {
        if (id) {
          window.gtag('event', 'page_view', {
            page_title: location.hash ? `${document.title} - ${location.hash}` : document.title,
            page_path: location.pathname + location.hash,
          });
        }
      }
    }
  }, [id]);
};

export default useAnalytics;
